import userService from '@/services/user-service'
import { ROLES } from '@/utils/consts'

export default {
    state: {
        token: localStorage.getItem('token') ?? null,
        currentUser: null
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setCurrentUser(state, user) {
            state.currentUser = user
        }
    },
    actions: {
        logout({ dispatch }) {
            dispatch('clearToken')
        },
        login({ dispatch }, [resp]) {
            if (resp.data.token) {
                dispatch('setToken', resp.data.token)
                dispatch('setCurrentUser')
            }
        },
        setCurrentUser({ commit }) {
            return userService.getCurrentUser().then((resp) =>
                commit('setCurrentUser', resp.data)
            )
        },
        setToken({ commit }, token) {
            localStorage.setItem('token', token)
            commit('setToken', token)
        },
        clearToken({ commit }) {
            localStorage.removeItem('token')
            commit('setToken', null)
        }
    },
    getters: {
        getToken: state => state.token,
        getCurrentUser: state => state.currentUser,
        isLoggedIn(state) {
            return state.token !== null
        },
        getCurrentUserPrivileges(state) {
            return state.currentUser?.privileges?.map(({ privilege }) => privilege) ?? null
        },
        isCurrentUserAdmin(state) {
            if (!state.currentUser?.role?.role) {
                return false
            }
            return state.currentUser.role.role !== ROLES.USER
        }
    }
}
